import { neutralColors } from './color';
import { borderWidths } from '../../eneco/default/tokens/border';

export * from '../../eneco/default/tokens/border';

export const primaryBorders = {
  primaryButtonBorder: `${borderWidths.m}  solid ${neutralColors.neutral900}`,
};

export const coloredBackgroundBorders = {
  onColoredBackgroundBorders: `${borderWidths.m}  solid ${neutralColors.black}`,
};
